import React from "react"
import Index from "../Index"
import { contentLayout, modules } from "../../config/pages"
import { useUser } from "../../contexts/UserContext"
import Forbidden from "../Forbidden"

function ViewOrders (){
  const {user} = useUser()
  let view = contentLayout[modules.OrdersList]
  if(user.permissions.views.length && !user.permissions.views.join().includes(modules.OrdersList.toLowerCase())){
    view = Forbidden
  }
  return(
  <Index content={view} module={modules.OrdersList}></Index>
 )
}

export default ViewOrders
